import React from "react";
import {useTranslation} from "react-i18next";
import {useFetch} from "../../../hooks/useFetch";
import {useStore} from "../../../hooks/useStore";

import {SelectField} from "./FilterComponentStyles";

const DrivingLicenseFilter = ({
    value,
    onChange,
    disabled = true,
    initialCall = true,
    mode = undefined,
    showAllOption = true,
    allowClear = false,
    ...props
}) => {
    const {t} = useTranslation([]);
    const stores = useStore();

    const [drivingLicenseTypesLoading, drivingLicenseTypes] = useFetch({
        defaultDataValue: [],
        fetchFn: stores.courierStore.listDrivingLicenseTypes.bind(null, {}),
        initialCall: initialCall
    });
    return (
        <React.Fragment>
            <h5>Sürücü Belgesi Tipi</h5>
            <SelectField
                showSearch
                loading={drivingLicenseTypesLoading}
                data-testid="drivingLicenseTypeSelect"
                value={value}
                onChange={onChange}
                disabled={disabled && drivingLicenseTypesLoading}
                mode={mode}
                filterOption={(input, option) =>
                    option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0 ||
                    option.props.value.toLowerCase().indexOf(input.toLowerCase()) >= 0
                }
                allowClear={allowClear}
                {...props}
            >
                {showAllOption && (
                    <SelectField.Option value="all" data-testid="option">
                        {t("filters.all", {ns: "common"})}
                    </SelectField.Option>
                )}
                {drivingLicenseTypes?.result &&
                    drivingLicenseTypes.result?.length > 0 &&
                    drivingLicenseTypes.result?.map(drivingLicenseType => (
                        <SelectField.Option
                            key={drivingLicenseType._id}
                            value={drivingLicenseType._id}
                            data-testid="drivingLicenseTypeSelect_option"
                        >
                            {drivingLicenseType.label.tr}
                        </SelectField.Option>
                    ))}
            </SelectField>
        </React.Fragment>
    );
};

export default DrivingLicenseFilter;
